import {useMutation, useQuery} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {handleResponse, queryClient} from "../setup";
import Noti from "../../../view/components/general/noti";
import {DiagnosisService} from "../../../services/requests/visit/diagnosis";

const useGetDiagnosisList = (params: any, tabIsCalled: boolean) => {
  return useQuery({
    queryKey: ["getDiagnosisList", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return DiagnosisService.getDiagnosisList(params);
    },
    enabled: (tabIsCalled) ?? true,
  });
}

const useGetDiagnosis = () => {
  return useMutation({
    mutationFn: DiagnosisService.getDiagnosis,
  })
}

const useAddDiagnosis = ({
 onSuccess
}: {
  onSuccess: () => void
}) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: DiagnosisService.addDiagnosis,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getDiagnosisList"] })
          onSuccess();
        }
      })
    },
  })
}

const useDeleteDiagnosis = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: DiagnosisService.deleteDiagnosis,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          console.log(data)
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getDiagnosisList"] })
          onSuccess();
        }
      })
    },
    onError: (error) => {
      Noti("error", error?.message)
    }
  })
}

export {
  useGetDiagnosisList,
  useGetDiagnosis,
  useAddDiagnosis,
  useDeleteDiagnosis
}
